import AuditLogsPage from './Page';
export default AuditLogsPage;
